// import React, { useEffect, useState } from 'react';
// import Navbar from './Navbar';
// import './IntroPage.css';
// import heroImage from './V-badiCopy.png';

// const stats = [
//   { value: '4', label: 'schools worked with' },
//   { value: '2', label: 'currently active' },
//   { value: '150+', label: 'students reached' },
//   { value: '2', label: 'years in Telangana' },
// ];

// const principles = [
//   {
//     title: 'We teach the specific, not the general.',
//     body:
//       "A session in Balanagar is about Balanagar's water, not global carbon statistics. Students engage with what they can verify themselves.",
//   },
//   {
//     title: "Awareness isn't the finish line.",
//     body:
//       "Every session ends with practical steps students can take themselves, and for those who want more, an introduction to organizations that can give them room to build. We don't run those programs. We make sure students know they exist and can reach them.",
//   },
//   {
//     title: 'We go where the gap is.',
//     body:
//       'We work in government schools in rural Telangana, where students live closest to these problems and are least often included in the conversation about them.',
//   },
// ];

// const testimonials = [
//   {
//     name: 'Harika',
//     details: 'Class 9, TGR Girls School, Balanagar',
//     quote:
//       'We learn about climate changes by you brother. Your are very intrested on environment it is good idea. We learn about different things on environment. It is very good idea to protect the environment. We too protect the climate. We grow trees, and we do not cut the trees. We save the water and air. We do not pollute our Earth. We also very intrested on saving the environment. You explained us very good things. We save the environment. Thank you brother for teaching us about climate.',
//   },
//   {
//     name: 'Pranitha',
//     details:
//       'Class 9, T.G.R. Girls, Balanagar (also signed by Akshaya, Lokeshwari, Aksa, Archana and Bhanupriya)',
//     quote:
//       'I am Pranitha from 9th standard at T.G.R. Girls Balanagar. Eroju miru vachinadkiku chala santhoshunnam. You enthakamudku maku climate antey chala theylusukunam anna. Maku eroju chala you are all happy to today. Anna eni chusi chala flat ayyam. Annayya mi talking, mi language baga unidhi annayya. I am very happy.',
//     translation:
//       'We were so happy that you came today. Thanks to you, we now understand what climate really means, brother. We were all so happy today. We were really impressed by everything we saw. Brother, the way you speak and explain things is very good. I am very happy.',
//   },
// ];

// const visitPhotos = [
//   '/photos/PHOTO-2026-08-27-00-05-47.jpg',
//   '/photos/PHOTO-2026-08-27-00-05-48.jpg',
//   '/photos/PHOTO-2026-08-27-00-05-48(1).jpg',
//   '/photos/PHOTO-2026-08-27-00-05-48(2).jpg',
//   '/photos/PHOTO-2026-08-27-00-05-48(3).jpg',
//   '/photos/PHOTO-2026-08-27-00-05-49.jpg',
//   '/photos/PHOTO-2026-08-27-00-05-49(1).jpg',
// ];

// const IntroPage = () => {
//   const [activePhoto, setActivePhoto] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setActivePhoto((current) => (current + 1) % visitPhotos.length);
//     }, 3500);

//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <div className="intro-page">
//       <Navbar />

//       <main className="home-scroll">
//       <section className="home-section hero-section" id="home">
//         <div
//           className="hero-art"
//           style={{ backgroundImage: `url(${heroImage})` }}
//           aria-hidden="true"
//         />
//         <div className="section-inner hero-inner">
//           <h1>
//             VBADI teaches students in India about the environmental problems
//             around them, and connects them with organizations where they can
//             build their own solutions.
//           </h1>
//         </div>
//       </section>

//       <section className="home-section purpose-section" id="why">
//         <div className="section-inner split-section">
//           <p className="section-label">Why this work exists</p>
//           <div className="section-copy">
//             <p>
//               In India the climate crisis is not a forecast. It is water that
//               isn't safe to drink, air that isn't safe to breathe, and heat that
//               decides whether a family's harvest survives.
//             </p>
//             <p>
//               Students already live with this. What they are rarely given is an
//               explanation of why it's happening, or any reason to believe they
//               can change it. Environmental education in most schools stops at
//               naming the problem.
//             </p>
//             <p>
//               We start where the students already are: with the problems they
//               can see from their own classroom.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="home-section work-section" id="work">
//         <div className="section-inner">
//           <p className="section-label">What we do</p>
//           <div className="wide-copy">
//             <p>
//               We run sessions in schools across Telangana on the environmental
//               issues affecting that specific community: what's causing them, and
//               what students can realistically do about them.
//             </p>
//             <p>
//               Sessions are built around questions rather than lectures.
//               Students are asked what they notice, what they think is behind it,
//               and what they would change. Most of the hour is them talking.
//             </p>
//             <p>
//               Understanding a problem isn't the same as being able to work on
//               one. So for students who want to go further, we connect them with
//               organizations like Inqui-Lab Foundation, which give them a space
//               to develop their own solutions from what they've learned. What
//               they build is theirs.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="stats-band" aria-label="By the numbers">
//         <div className="stats-grid">
//           {stats.map((stat) => (
//             <div className="stat-tile" key={stat.label}>
//               <span>{stat.value}</span>
//               <p>{stat.label}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       <section className="home-section origin-section" id="about">
//         <div className="section-inner story-grid">
//           <div>
//             <p className="section-label">How we started</p>
//             <img
//               className="founder-photo"
//               src="/photos/founder.jpeg"
//               alt="Abhinav Sattur"
//             />
//             <p className="founder-line">Abhinav Sattur, Founder</p>
//           </div>
//           <div className="section-copy">
//             <p>
//               VBADI began in my grandmother's community in Mahbubnagar. I had
//               spent summers there my whole life, and the environmental problems
//               I was reading about in class in Florida were the ones people I
//               knew were living with.
//             </p>
//             <p>
//               I started teaching in one school. In 2026 I returned to Telangana
//               and ran sessions in three more.
//             </p>
//             <p>
//               VBADI operates as an initiative of AIM for Seva (All India
//               Movement of Seva), a nonprofit founded in 2000 that runs over 260
//               education and community projects across 17 states in India.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="home-section principles-section" id="method">
//         <div className="section-inner">
//           <p className="section-label">How we work</p>
//           <div className="principles-list">
//             {principles.map((principle) => (
//               <article className="principle-item" key={principle.title}>
//                 <h2>{principle.title}</h2>
//                 <p>{principle.body}</p>
//               </article>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="home-section testimonials-section" id="students">
//         <div className="section-inner">
//           <div className="section-heading-row">
//             <p className="section-label">What students said</p>
//             <p className="testimonial-intro">
//               Students wrote these reflections after VBADI sessions in
//               Balanagar.
//             </p>
//           </div>
//           <div className="testimonial-list">
//             {testimonials.map((testimonial) => (
//               <figure className="testimonial" key={testimonial.name}>
//                 <blockquote>"{testimonial.quote}"</blockquote>
//                 {testimonial.translation && (
//                   <div className="translation">
//                     <p>Translated from Telugu:</p>
//                     <blockquote>"{testimonial.translation}"</blockquote>
//                   </div>
//                 )}
//                 <figcaption>
//                   <strong>{testimonial.name}</strong>
//                   <span>{testimonial.details}</span>
//                 </figcaption>
//               </figure>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="home-section photos-section" id="photos">
//         <div className="section-inner photos-inner">
//           <p className="section-label">Recent visit</p>
//           <div className="slideshow" aria-label="Photos from our recent visit">
//             {visitPhotos.map((photo, index) => (
//               <img
//                 className={index === activePhoto ? 'active' : ''}
//                 src={photo}
//                 alt={`VBADI recent visit ${index + 1}`}
//                 key={photo}
//               />
//             ))}
//           </div>
//           <p className="photo-caption">Photos from our recent visit.</p>
//           <div className="photo-dots" aria-hidden="true">
//             {visitPhotos.map((photo, index) => (
//               <span
//                 className={index === activePhoto ? 'active' : ''}
//                 key={`${photo}-dot`}
//               />
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="home-section vision-section" id="vision">
//         <div className="section-inner vision-inner">
//           <p className="section-label">Our vision</p>
//           <h2>
//             The students who live closest to India's environmental problems are
//             the ones best placed to solve them.
//           </h2>
//           <p>
//             We're working toward a generation that doesn't wait for permission
//             to start.
//           </p>
//         </div>
//       </section>

//       <section className="home-section contact-section" id="contact">
//         <div className="section-inner contact-inner">
//           <p className="section-label">Bring VBADI to your school</p>
//           <h2>
//             Tell us your school, city and roughly how many students, and we'll
//             come back with dates.
//           </h2>
//           <span className="contact-link">
//             email address
//           </span>
//         </div>
//       </section>
//       </main>

//       <footer className="site-footer">
//         <p>
//           VBADI operates as an initiative of AIM for Seva (All India Movement of
//           Seva).
//         </p>
//       </footer>
//     </div>
//   );
// };

// export default IntroPage;
import React from 'react';
import './IntroPage.css';

const IntroPage = () => {
  return (
    <main className="redesign-homepage">
      <iframe
        className="redesign-frame"
        src="/vbadi-redesign/index.html"
        title="VBADI homepage redesign"
      />
    </main>
  );
};

export default IntroPage;